import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "13", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 13h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 13h3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderGit";
const FolderGit = memo(themed(Icon));
export {
  FolderGit
};
//# sourceMappingURL=folder-git.js.map
